module.exports = __webpack_public_path__ + "img/videotext.f706c574.png";